import { clsx } from 'clsx';
import { useEffect, useRef, useState, type ReactNode } from 'react';

export interface MenuItem {
  key: string;
  label: ReactNode;
  icon?: ReactNode;
  onSelect?: () => void;
  danger?: boolean;
  active?: boolean;
  /** Ajratgich yoki sarlavha. */
  kind?: 'item' | 'separator' | 'label';
}

/** Oddiy ochiluvchi menyu: trigger + elementlar. Tashqariga bosilganda yopiladi. */
export function Dropdown({
  trigger,
  items,
  align = 'right',
  width,
  children,
}: {
  trigger: (props: { open: boolean; toggle: () => void }) => ReactNode;
  items?: MenuItem[];
  align?: 'left' | 'right';
  width?: number;
  children?: (close: () => void) => ReactNode;
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && setOpen(false);
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);
  const close = () => setOpen(false);
  return (
    <div ref={ref} style={{ position: 'relative', display: 'inline-flex' }}>
      {trigger({ open, toggle: () => setOpen((o) => !o) })}
      {open && (
        <div
          className="kts-menu"
          role="menu"
          style={{ top: 'calc(100% + 8px)', [align === 'right' ? 'right' : 'left']: 0, width }}
        >
          {children?.(close)}
          {items?.map((it) =>
            it.kind === 'separator' ? (
              <div key={it.key} className="kts-menu__sep" />
            ) : it.kind === 'label' ? (
              <div key={it.key} className="kts-menu__label">
                {it.label}
              </div>
            ) : (
              <button
                key={it.key}
                type="button"
                role="menuitem"
                className={clsx('kts-menu__item', it.danger && 'kts-menu__item--danger')}
                data-active={it.active ? 'true' : undefined}
                onClick={() => {
                  close();
                  it.onSelect?.();
                }}
              >
                {it.icon}
                <span style={{ flex: 1 }}>{it.label}</span>
              </button>
            ),
          )}
        </div>
      )}
    </div>
  );
}
